// payload.ts
// ProactivePlumber.com - payload schema + wire conversion
// Version: v09
// Date: 2025-12-23 (America/Denver)

export type LeadFormState = {
  fullName: string;
  phone: string;
  email: string;
  addressOrZip: string;
  serviceType: string;
  urgency: string;

  // Multi-select
  preferredContact: string[];
  preferredTime: string[];

  notes: string; // "Problem Description ( optional )"
  consentToText: boolean;
};

export type WireLeadPayload = Record<string, string>;

export function toWirePayload(params: {
  version: string;
  sourceDomain: string;
  state: LeadFormState;
}): WireLeadPayload {
  const { version, sourceDomain, state } = params;

  return {
    version: String(version),
    sourceDomain: String(sourceDomain),

    fullName: String(state.fullName || ""),
    phone: String(state.phone || ""),
    email: String(state.email || ""),
    addressOrZip: String(state.addressOrZip || ""),
    serviceType: String(state.serviceType || ""),
    urgency: String(state.urgency || ""),

    // Multi-select -> comma-separated strings
    preferredContact: (state.preferredContact || []).join(", "),
    preferredTime: (state.preferredTime || []).join(", "),

    notes: String(state.notes || ""),
    consentToText: String(Boolean(state.consentToText)),
    submittedAtIso: new Date().toISOString(),
  };
}
